/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AccountRoleName = 'svc.vcdrsp-prd' | 'svc.vcdrsp-stg' | 'svc.vcdrsp-ppr' | 'svc.vcdrsp-ngt';

export const AccountRoleName = {

    SVC_VCDRSP_PRD: 'svc.vcdrsp-prd' as AccountRoleName,

    SVC_VCDRSP_STG: 'svc.vcdrsp-stg' as AccountRoleName,

    SVC_VCDRSP_PPR: 'svc.vcdrsp-ppr' as AccountRoleName,

    SVC_VCDRSP_NGT: 'svc.vcdrsp-ngt' as AccountRoleName
};

